import cloneDeep from 'lodash.clonedeep';

const options = {
    shape: 'square',
    width: 300,
    height: 300,
    margin: 0,
    type: 'svg',
    qrOptions: {
        typeNumber: '0',
        mode: 'Byte',
        errorCorrectionLevel: 'M'
    },
    data: '',
    imageOptions: {
        hideBackgroundDots: true,
        imageSize: 0.4,
        margin: 0,
        crossOrigin: 'anonymous'
    },
    dotsOptions: {
        type: 'square',
        color: '#000000',
        gradient: null
    },
    backgroundOptions: {
        color: '#ffffff',
        gradient: null
    },
    image: null,
    cornersSquareOptions: {
        type: 'square',
        color: '#000000',
        gradient: null
    },
    cornersDotOptions: {
        type: 'square',
        color: '#000000',
        gradient: null
    }
};

const data = {
    alternate_redirect_url: [],
    asset: {
        description: '',
        files: [],
    },
    bitsignal: {
        authenticated: false,
        uid: '',
    },
    category: '',
    microsite: '',
    nickname: '',
    notes: '',
    pdf: {
        files: [],
    },
    redirect_url: '',
    survey: {
        description: '',
        post_survey_options: {
            message: '',
            title: '',
            url: ''
        },
        fields: [{
            archived: false,
            id: 'date',
            name: 'Timestamp',
            options: [],
            required: true,
            show: true,
            type: 'date',
        }]
    },
    tags: [],
    tracker: {
        description: '',
        fields: [{
            archived: false,
            id: 'date',
            name: 'Timestamp',
            options: [],
            required: true,
            show: true,
            type: 'date',
        }]
    },
};

const retailData = {
    active: true,
    category: null,
    nickname: "",
    qr_type: "link",
    redirect_url: "",
    tags: [],
}

export const getDefaultOptions = (id) => cloneDeep({
    ...options,
    data: `https://lqr.ai/${id}`,
});

export const getDefaultRetailData = (id, pid='') => {
  const clone = cloneDeep(retailData);
  clone.nickname = id;
  clone.redirect_url = `https://app.liquidqr.com/setup/${id}`;

  if (pid) {
      clone.product_id = pid
  };

  return clone;
}

export const getDefaultData = () => cloneDeep(data);
